import React from 'react'
import { useField, useFormikContext } from 'formik'
import Dropdown from 'particles/Dropdown'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { selectCountryList } from 'state/constants'
import MenuItem from 'particles/MenuItem'

interface CountryDropdownProps {
    name: string
    isReadOnly?: boolean
    label?: string
    subtext?: string
}

const CountryDropdown = ({ name, isReadOnly, label, subtext }: CountryDropdownProps) => {
    const [t] = useTranslation()
    const [field, meta] = useField(name)
    const { setFieldValue } = useFormikContext()
    const countryList = useSelector(selectCountryList)

    const handleChange = (value?: string) => {
        setFieldValue(name, value)
    }
    return (
        <Dropdown
            errorMessage={meta.touched && meta.error ? meta.error : undefined}
            label={label}
            subtext={subtext}
            isRequired
            onChange={value => handleChange(value as string)}
            value={field.value}
            renderValue={() => {
                if (field.value) {
                    return countryList.find(value => value.id === field.value)?.label
                } else {
                    return t('placeholderText.clickToSelect')
                }
            }}
            placeholder={t('placeholderText.clickToSelect')}
            isReadOnly={isReadOnly}
            labelSize="l"
            maxWidth={'100%'}
            dataTestId="test-business-country-dropdown"
        >
            {countryList?.map((item, index) => (
                <MenuItem.Text key={`menu-item-${item.id}`} tabIndex={index} text={item.label} value={item.id} />
            ))}
        </Dropdown>
    )
}

export default CountryDropdown
